<template>
	<el-form :model="form" ref='form' :rules="rules">
	  <el-form-item label="角色名称" prop="role_name" :label-width="formLabelWidth">
	    <el-input v-model="form.role_name" autocomplete="off"></el-input>
	  </el-form-item>

	  <el-form-item label="描述信息" prop="role_description" :label-width="formLabelWidth">
	    <el-input
	      type="textarea"
	      :rows="2"
	      placeholder="请输入内容"
	      v-model="form.role_description">
	    </el-input>
	  </el-form-item>
	  <el-form-item :label-width="formLabelWidth">
		  <span class="dialog-footer">
		    <el-button type="primary" @click="submit()">确 定</el-button>
		  </span>
	  </el-form-item>
	</el-form>
</template>

<script>
	export default{
		name:'RoleEdit',
		data(){
			return{
				form:{
					role_name:'',
					role_description:'',
				},
				formLabelWidth: '120px',
				rules:{
					role_name:[{
						required: true,
						message: '用户名不能为空',
						trigger: 'blur'
					}],
					role_description:[{
						required: true,
						message: '描述信息不能为空',
						trigger: 'blur'
					}],
				}
			}
			
		},
		
		methods:{
			// submit(){
			// 	this.httpPost({
			// 		url:'/admin/role/add',
			// 		data:{role_name:this.form.role_name,role_description:this.form.role_description}
			// 	}).then((res)=>{
			// 		this.$message.success(res.msg);
			// 	})
			// }
			submit(){
				this.$refs['form'].validate((valid)=>{
						if(valid){
							this.updateRole();
						}else{
							console.log('error submit!')
							return false;
						}
					})
				},
			updateRole(){
				let temp = this.cloneObj(this.form);
							
				this.msgBoxAjax(
				  '提示',
				  '确定修改吗？',
				  "/admin/role/add",
				  temp).then((data) => {
				  // console.log(data);
							
				  if (data.code == 1) {
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							
				      this.$router.go(-1);
				    });
				  }else{
							
				    this.messageCommon('错误',data.msg,'error');
				  }
							
							
				});
				}
			},
		created() {
			
		}
	}
</script>

<style>
</style>
